<template>
    <div :style="{'min-height':clientHeight+'px','background-color':'#F7F7F7','padding-bottom':'50px'}" id="outermost">
      <van-nav-bar
            title="核查记录"
            left-text="返回"
            left-arrow
            @click-left="$router.back()"
            id="topbar"
        />
      <div style="padding:20px">
        <van-search
            v-model="companyName"
            placeholder="请输入企业名称"
            @search="onSearch"
            shape="round"
            background="#F7F7F7"
          />
        <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              :immediate-check="false"
              >
              <div v-for="(item,index) in recordsList" :key="index" class="record">
                <div style="padding:0px 20px;border-bottom:1px solid #EBEEF5;">
                  <div class="typeTxt">
                      <span></span>
                      {{item.signTime}}
                  </div>
                  <van-row class="infoRow" align="center">
                      <van-col>企业名称：</van-col>
                      <van-col>{{item.companyName}}</van-col>
                  </van-row>
                  <van-row class="infoRow" align="center">
                      <van-col>所属项目：</van-col>
                      <van-col>{{item.projectName}}</van-col>
                  </van-row>
                  <van-row class="infoRow">
                      <van-col span="24" style="line-height:30px;">签到地点：</van-col>
                      <van-col style="line-height:20px;">{{item.signAddress}}<br>(<span>{{item.lng}}</span><span style="margin-left:10px;">{{item.lat}}</span>)</van-col>
                  </van-row>
<!--                  <van-row v-if="item.signPhotosId" class="infoRow">-->
<!--                      <van-col span="24" style="line-height:30px;">现场照片：</van-col>-->
<!--                      <van-col span="7">-->
<!--                        <img :src="apiUrl + 'download/' + item.signPhotosId" @click="showSignPhoto(item.signPhotosId)"/>-->
<!--                      </van-col>-->
<!--                  </van-row>-->
<!--                  <van-row v-else class="infoRow">-->
<!--                      <van-col>现场照片：</van-col>-->
<!--                      <van-col>无</van-col>-->
<!--                  </van-row>-->
<!--                  <van-row v-if="item.appendix.length>0" class="infoRow">-->
<!--                      <van-col span="24">核查材料：</van-col>-->
<!--                      <van-col span="24">-->
<!--                        <van-row type="flex" style="flex-flow:row wrap;">-->
<!--                          <van-col span='7' v-for="(appendix,i) in item.appendix" :key="i" style="margin-top:5px;margin-right:10px;">-->
<!--                            <img style="height:80px;width:100%;" :src="apiUrl + 'download/' + appendix.attachmentId" @click="showAppendixPhoto(item.appendix,i)"/>-->
<!--                          </van-col>-->
<!--                        </van-row>-->
<!--                      </van-col>-->
<!--                  </van-row>-->
<!--                  <van-row v-else class="infoRow">-->
<!--                      <van-col>核查材料：</van-col>-->
<!--                      <van-col>无</van-col>-->
<!--                  </van-row>-->
                </div>
              </div>

        </van-list>
      </div>

    </div>
</template>
<script>
    import $ from '@/fly'
    import Setting from '@/setting';
    import Vue from 'vue';
    import { ImagePreview } from 'vant';

    Vue.use(ImagePreview);
    export default {
        name: 'project-allWorkRecords',
        data () {
            return {
                clientHeight: window.screen.height,
                recordsList: [],
                loading: false,
                finished: false,
                apiUrl: Setting.apiBaseURL,
                companyName: ''
            }
        },
        computed: {
        },
        methods: {
            showSignPhoto (id) {
                ImagePreview({
                    images: [
                        Setting.apiBaseURL + 'download/' + id
                    ],
                    closeable: true
                });
            },
            showAppendixPhoto (appendixs, index) {
                var imageArr = [];
                appendixs.forEach(appendix => {
                    imageArr.push(Setting.apiBaseURL + 'download/' + appendix.attachmentId);
                });
                ImagePreview({
                    images: imageArr,
                    startPosition: index,
                    closeable: true
                });
            },
            onSearch () {
                this.loadList();
            },
            loadList () {
                var that = this;
                $.get('workRecords/getByProjectCompany', {
                    projectIds: localStorage.getItem('projectIds'),
                    companyIds: localStorage.getItem('companyIds'),
                    companyName: this.companyName
                }).then(res => {
                    that.recordsList = res;
                    // 加载状态结束
                    that.loading = false;
                    that.finished = true;
                })
            }
        },
        mounted () {
            this.loadList();
        }
    }

</script>

<style lang="less" scoped>
    .record{
      background-color: #FFFFFF;
      margin-bottom: 20px;
    }
    .typeTxt{
        font-size:30px;
        font-weight:bold;
        border-bottom: 1px solid #EBEEF5;
        padding: 25px 0px 15px 0px;
        letter-spacing: 1px;
    }
    .typeTxt span{
        width:5px;
        background-color:#50C9FF;
        display:inline-block;
        height: 34px;
        vertical-align:middle;
    }
    .infoRow{
        padding:20px 5px;
        font-size: 26px;
        font-weight: bold;
    }
    .infoRow .van-col:nth-child(1){
        color: #999999;
    }
    .picture{
      width:30%;
    }
    .van-search{
      padding: 0px;
    }
    .van-list{
      margin-top:20px;
    }
</style>
